










import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class PictureTeaserWidget extends Vue {
  @Prop({ type: String, default: '' }) readonly picture!: string
  @Prop({ type: String, default: '' }) readonly title!: string
  @Prop({ type: String, default: '' }) readonly text!: string
  @Prop({ type: String, default: '' }) readonly link!: string

  get styles() {
    if (this.picture !== '')
      return { 'background-image': `url(${this.picture})` }
    return {}
  }

  get href() {
    return this.link ?? '#'
  }
}
